/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details

  // Update the variant status
  let statusElement = document.getElementById('variant-status');
  if (variant.available) {
    statusElement.innerHTML = '<p class="s_instock">In stock</p>';
  } else {
    statusElement.innerHTML = '<p class="s_outofstock">Out of stock</p>';
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const mediaContainers = document.querySelectorAll('.media-container-video');

  mediaContainers.forEach(function(container) {
    const video = container.querySelector('video');
    const thumbnail = container.querySelector('.video-thumbnail');

    // Set the video height to match the thumbnail's height
    video.style.height = `${thumbnail.clientHeight}px`;

    // Add event listener to play video and hide thumbnail on click
    const playButton = container.querySelector('.play-button');
    playButton.addEventListener('click', function() {
      thumbnail.style.display = 'none';
      playButton.style.display = 'none';
      video.play();
    });
  });
});

var backToTopButton = document.getElementById('back-to-top');
if (backToTopButton) {
  backToTopButton.addEventListener('click', function() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        e.preventDefault();

        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
            const topOffset = 100;
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - topOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
  /*** Back to Top ***/
  var btt = document.getElementById("back-to-top-footer");

  window.addEventListener("scroll", function() {
    if (window.scrollY > 300) {
      btt.classList.add("show");
    } else {
      btt.classList.remove("show");
    }
  });

  btt.addEventListener("click", function(e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});

// Function to disable dark mode
function disableDarkMode() {
const darkModeStyles = document.querySelectorAll('[media*="prefers-color-scheme: dark"]');
darkModeStyles.forEach(style => style.remove());
}

document.addEventListener('DOMContentLoaded', () => {
  const logoList = document.querySelector('.logo-list__list_custom');
  const logoItems = [...document.querySelectorAll('.logo-list__item_custom')];

  // Duplicate the logo list 4 times
  const repeatCount = 4; // Duplicate the list 4 times
  for (let i = 0; i < repeatCount - 1; i++) {
    logoItems.forEach((item) => {
      const clone = item.cloneNode(true);
      logoList.appendChild(clone);
    });
  }

  // Calculate the total width of all logos in the list
  const totalWidth = logoList.scrollWidth;

  // Variable to track hover state
  let isHovered = false;

  // Pause or resume scrolling based on hover
  let scrollAmount = 0;
  const speed = 1;

  const infiniteScroll = () => {
    //if (!isHovered) { // If not hovered, continue scrolling
      scrollAmount += speed; // Scroll to the right

      // Reset position when the scroll reaches the end
      if (scrollAmount >= totalWidth / repeatCount) {
        scrollAmount = 0;
      }

      // Move the list using scrollLeft instead of transform
      logoList.scrollLeft = scrollAmount;
    //}

    // Request the next animation frame to continue scrolling
    requestAnimationFrame(infiniteScroll);
  };

  // Start scrolling when the DOM is fully loaded
  infiniteScroll();

  // Add hover events to pause scrolling when hovering over logos
  logoList.addEventListener('mouseenter', () => {
    isHovered = true; // Pause scrolling on hover
  });

  logoList.addEventListener('mouseleave', () => {
    isHovered = false; // Resume scrolling when hover is removed
  });
});

// Run the function on page load
window.addEventListener('load', disableDarkMode);